import React from 'react';
import styled from 'styled-components';
import { PaperPlane } from '@styled-icons/fa-solid';

const Button = styled(PaperPlane)`
  width: 2rem;
  height: 2rem;
  color: ${(props) => (props.$enabled ? 'var(--clr-purple)' : '#aaa')};
  padding: 0.25rem 0.25rem;
  font-size: var(--fs-h3);
  cursor: ${(props) => (props.$enabled ? 'pointer' : 'not-allowed')};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;

  &:focus {
    outline-width: 0px;
    box-shadow: 0 0 0 2pt #ccc;
  }

  &:hover {
    transform: ${(props) =>
      props.$enabled ? 'scale(1.1) translateY(-2px) rotate(-15deg)' : 'none'};
    color: ${(props) => (props.$enabled ? '#e0a0f0' : 'inherit')};
    filter: ${(props) =>
      props.$enabled
        ? 'drop-shadow(0 4px 8px rgba(192, 115, 222, 0.4))'
        : 'none'};
  }

  &:active {
    transform: ${(props) =>
      props.$enabled ? 'scale(0.95) rotate(-15deg)' : 'none'};
    transition: ${(props) =>
      props.$enabled
        ? 'all 0.1s ease'
        : 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'};
  }
`;

function SubmitButton(props) {
  return (
    <Button
      $enabled={props.enabled}
      onClick={props.onSubmit}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    />
  );
}

export default SubmitButton;
